import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const VFRI_LOGO = "https://customer-assets.emergentagent.com/job_global-youth/artifacts/bfuwt1m4_IMG_3812.png";
const BEST_DIPLOMATS_LOGO = "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/109oohjh_306603525_187834400379888_2096718961175502641_n.jpg";

export default function Partners() {
  return (
    <section 
      id="partners" 
      className="bg-white border-t border-black/10"
      data-testid="partners-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        
        {/* Section Header */}
        <div className="mb-12">
          <p className="text-[10px] tracking-[0.3em] uppercase text-muted mb-3">
            Partners
          </p>
          <h2 className="font-serif text-3xl lg:text-4xl text-ink">
            Institutional Partners
          </h2>
        </div>

        {/* Partners Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 mb-12">
          
          {/* Partner Card - VFRI */}
          <div 
            className="bg-paper p-8 hover:bg-white transition-colors"
            data-testid="partner-voice-for-rights-international"
          >
            <div className="h-20 flex items-center justify-center mb-6 border-b border-black/10 pb-6">
              <img 
                src={VFRI_LOGO}
                alt="Voice for Rights International"
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <p className="text-[10px] tracking-[0.2em] uppercase text-crimson mb-2">
              Strategic Partner
            </p>
            <h3 className="font-serif text-lg text-ink mb-2">
              Voice for Rights International
            </h3>
            <p className="text-sm text-muted leading-relaxed">
              International association promoting leadership, diplomacy, 
              and youth empowerment across global institutions.
            </p>
          </div>

          {/* Partner Card - Best Diplomats */}
          <div 
            className="bg-paper p-8 border-l border-black/10 hover:bg-white transition-colors"
            data-testid="partner-best-diplomats"
          >
            <div className="h-20 flex items-center justify-center mb-6 border-b border-black/10 pb-6">
              <img
                src={BEST_DIPLOMATS_LOGO}
                alt="Best Diplomats"
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <p className="text-[10px] tracking-[0.2em] uppercase text-crimson mb-2">
              Institutional Partner
            </p>
            <h3 className="font-serif text-lg text-ink mb-2">
              Best Diplomats
            </h3>
            <p className="text-sm text-muted leading-relaxed">
              Global platform for aspiring diplomats hosting Model UN 
              conferences at leading institutions worldwide.
            </p>
          </div>

          {/* Become Partner Card */}
          <div className="bg-paper p-8 border-l border-black/10 flex flex-col items-center justify-center text-center">
            <p className="text-[10px] tracking-[0.3em] uppercase text-muted mb-3">
              Join Our Network
            </p>
            <h3 className="font-serif text-xl text-ink mb-4">
              Become a Partner
            </h3>
            <p className="text-sm text-muted mb-6 max-w-xs">
              Collaborate with GYP to empower the next generation of global leaders.
            </p>
            <Link to="/partner">
              <button 
                className="border border-black/20 hover:border-ink hover:bg-ink hover:text-white text-ink px-6 py-3 text-xs tracking-[0.2em] uppercase transition-editorial flex items-center gap-2"
                data-testid="partners-cta-btn"
              >
                Inquire
                <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
              </button>
            </Link>
          </div>

          {/* Info Card */}
          <div className="bg-ink text-white p-8 border-l border-black/10">
            <p className="text-[10px] tracking-[0.3em] uppercase text-white/50 mb-6">
              Partnership Benefits
            </p>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <span className="text-crimson mt-1">—</span>
                <span>Access to international youth network</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-crimson mt-1">—</span>
                <span>Co-branded program development</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-crimson mt-1">—</span>
                <span>Global visibility and recognition</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-crimson mt-1">—</span>
                <span>Collaborative research opportunities</span>
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
}
